// Spiegelt domain/booking/workflow.py — bei Änderungen dort auch hier anpassen.

export const WORKFLOW_STEPS = [
  "Angelegt",
  "Bestätigt",
  "Konus Link versandt",
  "Konus-Daten eingegeben",
  "Infos an Gruppe versandt",
  "Abgereist",
  "Rechnung erstellt",
  "Bezahlt",
] as const;

export const STORNO_STATUS = "Storniert";
export const INTERN_STATUS = "Intern";

export const STATUS_COLOR_VAR: Record<string, string> = {
  "Angelegt":                "var(--status-new)",
  "Bestätigt":               "var(--status-confirm)",
  "Konus Link versandt":     "var(--status-konus-link)",
  "Konus-Daten eingegeben":  "var(--status-konus)",
  "Infos an Gruppe versandt":"var(--status-info)",
  "Abgereist":               "var(--status-done)",
  "Rechnung erstellt":       "var(--status-bill)",
  "Bezahlt":                 "var(--status-closed)",
  "Storniert":               "var(--status-cancel)",
  "Intern":                  "var(--status-intern)",
};

export function workflowStepIndex(status: string): number {
  const idx = WORKFLOW_STEPS.indexOf(status as typeof WORKFLOW_STEPS[number]);
  return idx === -1 ? 0 : idx;
}
